"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var prepareTextWithLinks = function prepareTextWithLinks(str) {
  var urlPattern = /https?:\/\/[^\s]+/g;
  var textWithLinks = str.replace(urlPattern, function (url) {
    return "<a href=\"".concat(url, "\" target=\"_blank\">").concat(url, "</a>");
  });
  return textWithLinks;
};
var _default = exports["default"] = prepareTextWithLinks;